import * as React from 'react';
import { colors } from '../../../index';

const IconFile = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 10 12",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.105 0H.775C.369 0 .039.288.039.643v10.466c0 .355.33.643.736.643h8.473c.406 0 .736-.288.736-.643V3.173a.6.6 0 00-.215-.455L6.618.181A.79.79 0 006.105 0zm2.96 10.949H.958V.804h4.403v2.155c0 .476.443.863.988.863h2.714v7.127zM6.35 3.019c-.037 0-.068-.027-.068-.06V1.267L8.427 3.02H6.35zM2.546 4.748h5v.803h-5v-.803zm0 1.34h5v.803h-5v-.804zm0 1.338h5v.804h-5v-.804zm0 1.34h2.853v.803H2.546v-.803z",
    fill: "currentColor"
  }));
};

export default IconFile;